import React, { memo, useCallback, useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

export const Select = memo(
  ({ onChange, name, value, label, id, list = [], idKey = 'id', labelKey = 'label', hasLabel = true }) => {

    const [selected, setSelected] = useState(null)
    const [isShow, setIsShow] = useState(false)


    const onBlur = useCallback(() => {
      setTimeout(() => setIsShow(false), 200);
    }, []);

    const handleChoose = useCallback((data) => {
      onChange({ target: { name, value: data[idKey] } })
      setSelected(data)
      onBlur()
    }, [idKey, name, onBlur, onChange])

    useEffect(() => {
      if (value || value === 0) {
        const currentSelected = list.find(item => item[idKey].toString() === value.toString())
        setSelected(currentSelected)
      }
    }, [idKey, list, value])

    const memoValue = useMemo(() => {
      if (selected?.[idKey] === value && hasLabel) return selected?.[labelKey]
      return value
    }, [hasLabel, idKey, labelKey, selected, value]);


    return (
      <div className="relative flex flex-col font-medium flex-1">
        <input
          className="group text-slate-900 px-3 py-3 rounded text-sm outline-none border border-slate-300 focus:border-red-600 transition-all duration-300"
          id={id || name}
          name={name}
          autoComplete="off"
          value={memoValue}
          onFocus={() => setIsShow(true)}
          onChange={() => { }}
          onBlur={onBlur}
        />
        <label
          htmlFor={id || name}
          className="transform -translate-y-[50px] bg-white text-sm mx-3 text-slate-400 self-start transition-all duration-300"
        >
          {label}
        </label>
        <div className="absolute right-4 top-3" onClick={() => setIsShow(!isShow)}>
          {isShow ?
            <FaChevronUp className='text-slate-300' />
            :
            <FaChevronDown className='text-slate-300' />
          }
        </div>
        {isShow &&
          <div className="absolute top-12 bg-white shadow-lg right-0 left-0 z-40 h-44 overflow-y-auto rounded h-auto max-h-44">
            {list.length ? list.map(item => (
              <div key={item[idKey]} className="hover:bg-red-50 hover:text-red-600 px-4 py-2 text-sm cursor-pointer text-slate-700" onClick={() => handleChoose(item)}>
                {item[labelKey]}
              </div>
            )) :
              <div className="text-center text-slate-400">No Data</div>}
          </div>
        }
      </div>
    );
  }
);

Select.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  idKey: PropTypes.string,
  labelKey: PropTypes.string,
  onChange: PropTypes.func,
  list: PropTypes.array,
  hasLabel: PropTypes.bool
}
